export default "__VITE_ASSET__DKrbERfw__"